import type { LocalisedCategory } from '../useCategoriesConfig';
import type { Category } from './categories';

export const localisedPackagingCategories = (
    categories: Record<string, Category>
): LocalisedCategory => ({
    'da-DK': [],
    'de-AT': [],
    'de-CH': [],
    'de-DE': [],
    'en-AU': [],
    'en-CA': [],
    'en-GB': [],
    'en-IE': [],
    'en-IN': [],
    'en-NZ': [],
    'en-SG': [],
    'en-US': [
        categories.shippingBoxesMailers,
        categories.productBoxes,
        categories.shoppingBags,
        categories.customPouches,
        categories.foodPackaging,
        categories.packagingAccessoriesTags,
        categories.shippingLabels,
    ],
    'fi-FI': [],
    'fr-BE': [],
    'fr-CA': [],
    'fr-CH': [],
    'fr-FR': [],
    'it-CH': [],
    'it-IT': [],
    'nb-NO': [],
    'nl-BE': [],
    'nl-NL': [],
    'pt-PT': [],
    'sv-SE': [],
    'es-ES': [],
    'es-US': [
        categories.shippingBoxesMailers,
        categories.productBoxes,
        categories.customPouches,
        categories.shoppingBags,
        categories.foodPackaging,
        categories.packagingAccessoriesTags,
        categories.shippingLabels,
    ],
});
